import axios from 'axios';
import { dispatch } from '../redux/store';
import { BASE_URL } from '../utils/constants';
import { getSingleModel } from '../utils/helpers';

export const apiClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    }
});

apiClient.interceptors.request.use(
    async req => {
        const splitedUrl = (req.url || '').split('/');
        const currentEndpoint = splitedUrl[splitedUrl.length - 1];

        const search = new URLSearchParams(window.location.search);
        const shareToken = search.get('shareToken');

        if (shareToken) {
            req.headers['guesttoken'] = shareToken;
        }

        if (currentEndpoint === 'refresh-token') {
            const authModel = getSingleModel('auth');
            const refreshToken = authModel?.authUser?.refreshToken;
            if (refreshToken) {
                req.headers.Authorization = `Bearer ${refreshToken}`;
            }
            return req;
        }

        const authModel = getSingleModel('auth');
        if (authModel?.authUser?.token) {
            req.headers.Authorization = `Bearer ${authModel.authUser.token}`;
        }
        return req;
    },
    error => Promise.reject(error)
);

apiClient.interceptors.response.use(
    response => response,
    async error => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message;

        if (status === 401 && message === 'jwt expired') {
            const newAccessToken = await dispatch.auth.refreshToken();
            if (newAccessToken) {
                const config = error.config;
                config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return apiClient(config);
            }
        }
        if (status === 401 && message !== 'jwt expired') {
            await dispatch.auth.logout();
        }
        return Promise.reject(error);
    }
);

export default {
    post: async (url, data, options) =>
        apiClient.post(url, data, options && { headers: options }),
    patch: async (url, data, options) =>
        apiClient.patch(url, data, options && { headers: options }),
    put: async (url, data, options) =>
        apiClient.put(url, data, options && { headers: options }),
    delete: async (url, data, options) => {
        let modData = data;
        modData = data
            ? data instanceof Object && !Object.keys(data).length
                ? null
                : data
            : null;
        const config = modData
            ? { headers: options, data }
            : { headers: options };
        return apiClient.delete(url, config);
    },
    get: async (url, params, options) => {
        let modParams = params;
        modParams = params
            ? params instanceof Object && !Object.keys(params).length
                ? null
                : params
            : null;
        const config = modParams
            ? { headers: options, params }
            : { headers: options };
        return apiClient.get(url, config);
    }
};
